<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
  [compareWith]="compareObjects" [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of result" [value]="item" [selected]="isSelected(item)">
    {{item.tipo }}
  </mat-list-option>
</mat-selection-list>